import { CSSTransition } from "react-transition-group";
import clsx from "clsx";

import { useRef, useState, useEffect } from "react";

interface SlideDownProps {
  visible: boolean;
  className?: string;
  children: React.ReactNode;
  timeout?: number;
  disableExit?: boolean;
  disableAppear?: boolean;
}

export function SlideDown(props: SlideDownProps): JSX.Element {
  const { children } = props;
  const { visible, className } = props;
  const timeout = props.timeout || 500;
  const exit = props.disableExit ? false : true;
  const appear = props.disableAppear ? false : true;

  const ref = useRef(null);
  const [styles, setStyles] = useState({ default: {}, transitions: {} });

  useEffect(() => {
    if (!ref.current) return;

    const originalHeight = ref.current.scrollHeight;
    const heightCss = `${originalHeight}px`;
    setStyles({
      default: { overflow: "hidden" },
      transitions: {
        entering: {
          height: heightCss,
          transition: `height 500ms ease-out`
        },
        entered: { height: heightCss },
        exiting: {
          height: "0px",
          transition: `height 500ms ease-out`,
          overflow: "hidden"
        },
        exited: { height: "0px" }
      }
    });
  }, [children]);

  return (
    <CSSTransition
      appear={appear}
      in={visible}
      timeout={timeout}
      exit={exit}
      mountOnEnter={true}
    >
      {(state) => {
        return (
          <div
            ref={ref}
            style={{
              ...styles.default,
              ...styles.transitions[state],
              transitionDuration: timeout
            }}
            className={clsx({ [className]: visible })}
          >
            {children}
          </div>
        );
      }}
    </CSSTransition>
  );
}
